import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { renderElementExerciseGapFill } from './renderElementExerciseGapFill';
import { EXERCISE_GAP_FILL_HINTS, ExerciseGapFillOptions } from './types';
import { ExerciseGapFillReadOnlyPlugin } from './ExerciseGapFillReadOnlyPlugin';

export const ExerciseGapFillPlugin = (options?: ExerciseGapFillOptions): SlatePlugin => {
  if (options.isReadOnly) {
    return ExerciseGapFillReadOnlyPlugin(options);
  }
  return {
    renderElement: renderElementExerciseGapFill(options),
    voidTypes: [EXERCISE_GAP_FILL_HINTS],
  };
};
